import CommonAffiliateBadge from 'common/components/entities/AffiliateBadge'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import React, { useEffect, useState } from 'react'
import useManagement, { selectors } from '../hooks/useManagement'

function AffiliateBadge() {
  const [isClient, setIsClient] = useState(false)
  const affiliateLink = useManagement(selectors.getAffiliateLink)
  const pageLocale = usePage(pageSelectors.getLocale)
  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    isClient && (
      <CommonAffiliateBadge
        pageLocale={pageLocale}
        affiliateLink={affiliateLink}
      />
    )
  )
}

export default AffiliateBadge
